import React from "react";
import { Field } from "redux-form";
import { renderField, renderMaskedField } from "../../../../../utils/renderField";
import { required, fieldLength16, number, zipCodeCheck } from "../../../../../utils/formValidators";

const AuthDebitFields = (props) => {
  const twoNumbersMask = [/[0-9]/, /[0-9]/];
  const fourNumbersMask = [...twoNumbersMask, ...twoNumbersMask];
  const expDateMask = [...twoNumbersMask, "/", ...twoNumbersMask];
  const debitMask = [
    ...fourNumbersMask,
    " ",
    ...fourNumbersMask,
    " ",
    ...fourNumbersMask,
    " ",
    ...fourNumbersMask,
  ];

  return (
    <section>
      <div className="py-4 f18 bold">Debit Card Information</div>
      <div className="mb-3">
        <Field
          label="Name on Card"
          name="nameOnCard"
          component={renderField}
          validate={[required]}
          type="text"
          e2eId="nameOnCard"
        />
      </div>
      <div className="mb-3">
        <Field
          component={renderMaskedField}
          label={"Debit Card Number"}
          mask={debitMask}
          name="account_nbr"
          validate={[number, required, fieldLength16]}
          type="text"
          inputMode="numeric"
          e2eId="cardNumber"
        />
      </div>
      <div className="row mb-3 row-no-gutters">
        <div className="col-6">
          <Field
            component={renderMaskedField}
            mask={expDateMask}
            label="Exp Date"
            name="exp_date"
            placeholder="MM/YY"
            validate={[required, number]}
            type="text"
            inputMode="numeric"
            e2eId="expirationDate"
          />
        </div>
        <div className="col-6">
          <Field
            component={renderField}
            label="CVC"
            name="cvv2"
            //   tooltip={cvvToolTip}
            validate={[required, number]}
            type="text"
            inputMode="numeric"
            e2eId="cvv"
          />
        </div>
      </div>
      <div className="row mb-3 row-no-gutters">
        <div className="col-6">
          <Field
            component={renderField}
            label="Zip Code"
            name="zip_code"
            validate={[required, number, zipCodeCheck]}
            type="text"
            inputMode="numeric"
            e2eId="zipCode"
          />
        </div>
        <div className="col-6"></div>
      </div>
    </section>
  );
};

export default AuthDebitFields;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/auth-debit-fields.component.js